import React from 'react';

import { useIntl } from 'react-intl';

import EyeOpenStrikethroughIcon from '@atlaskit/icon/core/eye-open-strikethrough';
import { ButtonMenuItem } from '@atlaskit/side-nav-items/button-menu-item';

import { useMoreMenuDragAndDrop } from '../use-more-menu-drag-and-drop';

import { messages } from './messages';

export function HideFromSidebarButton(): React.JSX.Element {
	const { formatMessage } = useIntl();
	const { dropIndicator, dropTargetRef, moreButtonRef } = useMoreMenuDragAndDrop();

	return (
		<ButtonMenuItem
			elemBefore={<EyeOpenStrikethroughIcon label="" />}
			ref={moreButtonRef}
			dropIndicator={dropIndicator}
			visualContentRef={dropTargetRef}
		>
			{formatMessage(messages.hideFromSidebar)}
		</ButtonMenuItem>
	);
}
